import { TOrderCreateFormData } from '../../types'
import { ValidationValuesRange } from './types'

export const minMaxSpecialCondition =
  (defaults: ValidationValuesRange, specials: ValidationValuesRange, metric: undefined | string = '') =>
  (value: number, allValues: TOrderCreateFormData) => {
    const defaultValues = { min: 0, max: 0 }
    const { min, max } = { ...defaultValues, ...(allValues?.customer?.hasSpecialCargoLimits ? specials : defaults) }

    if (min === 0 && max === 0) {
      return undefined
    }

    if (!isNaN(value) && (value > max || value < min)) {
      return [`Допустимо значение от ${min} до ${max}`, metric].filter(Boolean).join(' ')
    }
  }

/**
 * Валидатор с учетом лимитов терминалов
 * Лимиты терминалов имеют приоритет над всеми остальными ограничениями
 *
 * @param defaults - стандартные ограничения
 * @param specials - ограничения для привилегированных заказчиков
 * @param terminalLimit - лимит терминала (имеет приоритет)
 * @param metric - единица измерения для сообщения об ошибке
 */
export const minMaxWithTerminalLimit =
  (
    defaults: ValidationValuesRange,
    specials: ValidationValuesRange,
    terminalLimit: number | undefined,
    metric: undefined | string = ''
  ) =>
  (value: number, allValues: TOrderCreateFormData) => {
    const defaultValues = { min: 0, max: 0 }
    // eslint-disable-next-line prefer-const
    let { min, max } = { ...defaultValues, ...(allValues?.customer?.hasSpecialCargoLimits ? specials : defaults) }

    if (terminalLimit !== undefined && terminalLimit > 0) {
      max = Math.min(max, terminalLimit)
    }

    if (min === 0 && max === 0) {
      return undefined
    }

    if (!isNaN(value) && (value > max || value < min)) {
      return [`Допустимо значение от ${min} до ${max}`, metric].filter(Boolean).join(' ')
    }
  }
